import { httpClient } from '@/shared/api/httpClient'

import type { MyChatSummary } from '../types/messages.types'

export const messagesApi = {
  listMyChats: (): Promise<MyChatSummary[]> =>
    httpClient.get<MyChatSummary[]>('/me/chats').then((r) => r.data),
}
